import * as stage from './stage';

export const sharedEnvConfig = (window.sharedEnvConfig = {
  ...stage.sharedEnvConfig,
  ...window.sharedEnvConfig,
  /* eslint-disable */
  telemetryFn: function (metadata: import('@mojang/telemetry').IMetadata, data: any) {
    console.log('🔥', metadata, data);
  }
  /* eslint-enable */
});

export const bundleConfig = {
  ...stage.bundleConfig,
  'enable.onestoreWallet': true,
  'enable.postMigration': true,
  'url.platform2.0IframeURL': 'https://mc-dev.minecraft.net/content/minecraftnet/language-masters/en-us/jcr:content.customfooterlibs.html',
  environmentName: 'PPE'
};
